
// export var requestUrl = 'http://183.162.251.135:16000/api/'
// export var requestUrl = 'http://220.180.250.13:16000/api/'
//赵伦伦：
export var requestUrl = 'https://cloud.keyetech.com/train-service-api/'
//汪松：
// export var requestUrl = 'http://111.39.248.31:16000/api/'

